import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ProductService } from '../../shared/services/product.service';
import { ProductFamily } from '../productfamily/productfamily.model';
import { Subscription } from 'rxjs/Subscription';
import { OPCConstant } from '../opc.const';
import { ProductLine } from './productline.model';
import { OPCSettings } from '../../shared/models/opcsettings.model';

@Component({
  selector: 'app-productline',
  templateUrl: './productline.component.html',
  styleUrls: ['./productline.component.css']
})

export class ProductLineComponent implements OnInit {

  productFamilyID: number;
  productFamilyName: string;
  productFamilies: ProductFamily[];
  subscription: Subscription;
  intallationpartsFamily: ProductFamily;
  byPassFamilyName: string;
  productLines: ProductLine;
  defaultImage: string;
  activeItem: string;
  productFamilyImgURL: string;
  opcSettings: OPCSettings = new OPCSettings();

  constructor(private _route: ActivatedRoute, private _productService: ProductService, private _router: Router) {
    this.byPassFamilyName = OPCConstant.BYPASS_FAMILY;
  }

  getProductLine() {
      this._productService.getProductLineById(this.intallationpartsFamily.productFamilyID).subscribe(res => {
        this.productLines = res.productLines[0];
      });
  }

  onSelect(pf: ProductFamily) {
    this.activeItem = pf.productFamilyName;
  }
  getProductFamilies() {
    this._productService.getProductFamily().subscribe((productFamilies: ProductFamily[]) => {
      this.productFamilies = productFamilies;
      const pf = this.productFamilies.find(p => p.productFamilyID === this.productFamilyID);
      this.activeItem = pf ? pf.productFamilyName : '';
      this.intallationpartsFamily = this.productFamilies.find(p => p.productFamilyName === this.byPassFamilyName);
      this.productFamilies = this.productFamilies.filter(p => p.productFamilyName !== this.byPassFamilyName);
      this.getProductLine();
    });
  }
  errorImage(event) {
    //event.target.src = this.defaultImage;
  }
  ngOnInit() {
    this._route.params.subscribe(
      (params: Params) => {
        this.productFamilyID = +params['pfid'];
        this.getProductFamilies();
      }
    );
    this.getProductFamilies();
  }

}



// WEBPACK FOOTER //
// ./src/opc/opc-app/productline/productline.component.ts